import { instance } from '../instance'

/**
 * Return information about website
 *
 * @param {string} [region] - License region (uk, lv)
 * @returns {Promise<AxiosResponse<any>>}
 */
export const getInfo = (region) => {
  return instance.get('/v2/info', {
    skipAuth: true,
    params: region ? { r: region } : undefined,
  })
}
